import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createVNode as _$cv, className as _$cn, createUnknownComponentVNode as _$cc, createElementVNode as _$ce } from 'intact-vue';
import { Button } from '../button';
import { getRestProps } from '../utils';
import { makeStyles } from './styles';
import { Icon } from '../icon';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    className = _this$get.className,
    children = _this$get.children,
    vertical = _this$get.vertical,
    size = _this$get.size,
    type = _this$get.type;
  var _this$scroll = this.scroll,
    isScroll = _this$scroll.isScroll,
    offset = _this$scroll.offset,
    enablePrev = _this$scroll.enablePrev,
    enableNext = _this$scroll.enableNext,
    prev = _this$scroll.prev,
    next = _this$scroll.next,
    scrollRef = _this$scroll.scrollRef,
    wrapperRef = _this$scroll.wrapperRef;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-tabs"] = true, _classNameObj[k + "-size-" + size] = size, _classNameObj[k + "-vertical"] = vertical, _classNameObj[k + "-type-" + type] = true, _classNameObj[k + "-is-scroll"] = isScroll.value, _classNameObj[className] = className, _classNameObj[makeStyles(k)] = true, _classNameObj);
  return _$cv('div', _extends({
    'className': _$cn(classNameObj)
  }, getRestProps(this)), [isScroll.value ? _$cc(Button, {
    'className': _$cn(k + "-tabs-prev"),
    'type': 'none',
    'icon': true,
    'key': 'prev',
    'size': size,
    'disabled': !enablePrev.value,
    'ev-click': prev,
    'children': _$cc(Icon, {
      'className': _$cn(vertical ? k + "-icon-up" : k + "-icon-left")
    })
  }, 'prev') : undefined, _$ce(2, 'div', _$ce(2, 'div', [children, _$ce(2, 'div', null, 1, _$cn(k + "-tabs-active-bar"), {
    'style': this.activeBar.value
  })], 0, _$cn(k + "-tabs-wrapper"), {
    'style': {
      transform: vertical ? "translateY(" + offset.value + "px)" : "translateX(" + offset.value + "px)"
    }
  }, null, wrapperRef), 2, _$cn(k + "-tabs-scroll c-clearfix"), null, null, scrollRef), isScroll.value ? _$cc(Button, {
    'className': _$cn(k + "-tabs-next"),
    'type': 'none',
    'icon': true,
    'key': 'next',
    'size': size,
    'disabled': !enableNext.value,
    'ev-click': next,
    'children': _$cc(Icon, {
      'className': _$cn(vertical ? k + "-icon-down" : k + "-icon-right")
    })
  }, 'next') : undefined]);
}
;